import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState();

  useEffect(() => {
    setState(command.data.state);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="State">
        <Select name="state" value={state} onChange={handleBlur} className={cx('select')}>
          <option value={3}>Multicopter</option>
          <option value={4}>Fixed-wing</option>
        </Select>
      </FieldRow>
    </div>
  );
};

export default Command;
